
import axios from "axios";
import { apiPath, apiPath1 } from "../../constants/config";
let token = localStorage.getItem("accessToken");
// token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7InBvaW50cyI6eyJwb2ludHNnYWduZXMiOltdLCJwb2ludHNjb25zb21tZXMiOltdfSwiZGF0ZSI6IjIwMjItMDktMTZUMTQ6MjA6MDMuMjM3WiIsIl9pZCI6IjYzMjQ4NjEzODcxNTg0MDUyYzk1MjE1YSIsIm5vbSI6Imxhc3QiLCJwcmVub20iOiJsYXN0IiwiZW1haWwiOiJhQGEuY29tIiwicGFzc3dvcmQiOiIkMmEkMTAkUjUzREJpZE14S0lvVlRCMWxKa3UxLmNyM1BSZnJmbjVOVm9zTVE4cHdPZFBjTGFvSzNKNzYiLCJ0ZWxlcGhvbmUiOiIwMTI0NTYzNCIsImFkcmVzc2UiOiIwMTI0NTYzNCIsIl9fdiI6MH0sImlhdCI6MTY2NDE4Nzg0MH0.51YHBOBahTfdCoQvFIMlBUTWAQxV5vPlVPP0CHuEBAg"
let config = {
    headers: {
        Authorization: "Bearer " + token
    }
};
const state = {
    isLoadClients: false,
    clientProg: null,
    cltprg: null,
    cltprgpardate: null,
    lastthree: null,
    connected : null
    // restaurant,
    // menu
};

const getters = {
    isLoadClients: state => state.isLoadClients,
    clientProg: state => state.clientProg,
    cltprg: state => state.cltprg,
    cltprgpardate: state => state.cltprgpardate,
    lastthree: state => state.lastthree,
    connected: state => state.connected,

    // restaurant: state => state.restaurant,
    // menu: state => state.menu,
};

const mutations = {
    isConnected(){
        state.connected = localStorage.getItem("accessToken")
    },
    getClientSuccess(state, payload) {
        state.isLoadClients = true;
        state.clientProg = payload.clientProg;
        state.cltprg = payload.cltprg;
    },

    getClientError(state, error) {
        state.isLoadClients = false;
    },
    editClientSuccess(state, payload, error) {
        state.clientProg = payload.user
    },
    getLatestSuccess(state, payload) {
        state.clientProg = payload.clientProg;
        state.lastthree = payload.lastthree
    },
    getCltDateSuccess(state, payload) {
        state.cltprgpardate = payload.cltprgpardate;
    }

};

const actions = {
    async getClientProg({ commit }) {
        // token = localStorage.getItem("accessToken")
        return await axios
            .get(`${apiPath}/client`, config)
            .then(r => r.data)
            .then(res => {
                if (res.ok) {
                    commit("getClientSuccess", {
                        clientProg: res.user,
                        cltprg: res.clientprog
                    });
                } else {

                    commit("getClientError");

                }
                return res
            });
    },
    async getlastthree({ commit }) {
        // token = localStorage.getItem("accessToken")
        return await axios
            .get(`${apiPath}/latest-clientprog`, config)
            .then(r => r.data)
            .then(res => {
                if (res.ok) {
                    commit("getLatestSuccess", {
                        clientProg: res.user,
                        lastthree: res.last_three
                    });
                } else {
                    commit("getClientError");
                }
                return res
            });
    },
    async loginProg({ commit }, payload) {
        return await axios
            .post(`${apiPath}/login`, payload)
            .then(res => res.data)
            .then(res => {
                console.log(res)
                if (res.ok) {
                    commit("loginSuccess", res)
                    localStorage.setItem("accessToken", res.data)
                    token = res.data;

                    // restaurant= res.restaurant;
                    // menu=res.menu;
                    config = {
                        headers: {
                            Authorization: "Bearer " + token
                        }
                    };

                } else {
                    commit("getClientError");
                }
                return res;
            });
    },
    async earn({ commit }, payload) {
        return await axios
            .post(`${apiPath}/ajoutpts`, payload)
            .then(res => res.data)
            .then(res => {
                console.log(payload)
                return res;
            });
    },
    async filterbydate({ commit }, payload) {
        return await axios
            .get(`${apiPath}/filterdate?maxdate=${payload.maxdate}&mindate=${payload.mindate}`, config)
            .then(res => res.data)
            .then(res => {
                if (res.ok) {
                    commit("getCltDateSuccess", {
                        cltprgpardate: res.data,
                    });
                }
                return res;
            });
    },
    async editClient({ commit }, payload) {
        return axios
            .post(`${apiPath}/update-client`, payload.form, config)
            .then(r => r.data)
            .then(res => {
                if (res.ok) {
                    commit("editClientSuccess", res);
                }
                return res;
            });
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
